<!-- eslint-disable vue/no-unused-vars -->
<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#">
                <b-icon icon="person-square"></b-icon> ອັບເດດບັນຊີທົ່ວໄປ
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
            
                <b-nav-item >
                    <b-button-group>
                        <b-button variant="success" @click="onUpdatePosting">
                        <b-icon icon="cloud-check-fill" aria-hidden="true" variant="light"></b-icon> ອັບເດດການລົງບັນຊີ
                    </b-button>
                    <b-button variant="secondary"   @click.prevent="onPreview"    >
                            <b-icon icon="printer" aria-hidden="true"  variant="light"></b-icon> ພີມບັດຜ່ານບັນຊີ
                        </b-button>
                    </b-button-group>
                    
                </b-nav-item>

                <b-nav-item @click="goback()">
                    <b-button variant="danger">
                        <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon> ປິດ
                    </b-button>

                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>


        <b-form @submit="onUpdatePosting">

            <b-row>
                <b-col>
                    <b-card>
                        <b-row>
                            <b-col>
                                <b-form-group label-cols="4" label-cols-lg="2" label="ເນື້ອໃນ:">
                                    <b-form-input v-model="gltrans.description"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-cols="4" label-cols-lg="2" label="ລູກຄ້າ:">
                                    
                                    <b-input-group>
                                    
                                        <b-form-input v-model="gltrans.customer_name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="outline-success">...</b-button>
                                             
                                        </b-input-group-append>
                                    </b-input-group>


                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="ບັດຜ່ານບັນຊີ:" label-cols="12" label-cols-lg="4">
                                    <b-form-select v-model="gltrans.trans_type_code" :options="glbook" required trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="ເງິສົດ/ເງິນໂອນ:" label-cols="12" label-cols-lg="4">
                                    <b-form-select v-model="gltrans.payment_type_id" :options="payment_types" required
                                        trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>

                                <b-form-group label-cols="12" label-cols-lg="4" label="ເລກທີ່ເອກະສານອ້າງອີງ:">
                                    <b-form-input v-model="gltrans.ref_doc_no"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ແຫຼ່ງທືນ:">
                                    <b-form-select v-model="gltrans.funding_code" :options="source_fund" required trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>



                        <b-row>


                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ກົມ:">
                                    <b-form-select v-model="gltrans.dep_code" :options="dep" required trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ລະຫັດໂຄງການ:">
                                    <b-form-input v-model="gltrans.proj_code"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>


                    </b-card>
                </b-col>

                <b-col cols="12" md="4">

                    <b-card>
                        <b-form-group label-cols="4" label-cols-lg="3" label="ບິນເລກທີ່">
                            <b-form-input v-model="gltrans.doc_no"></b-form-input>
                        </b-form-group>


                        <b-form-group label-cols="4" label-cols-lg="3" label="ວັນທີ">
                            <b-form-datepicker id="datepicker-placeholder" v-model="gltrans.doc_date"
                                placeholder="ເລືອກບັນທີ" locale="lao">
                            </b-form-datepicker>
                        </b-form-group>

                        <b-form-group label-cols="4" v-model="gltrans.ref_doc_no" label-cols-lg="3"
                            label="ເລກທີ່ໃບອະນຸມັດ">
                            <b-form-input></b-form-input>
                        </b-form-group>

                        <b-form-group label-cols="4" label-cols-lg="3" label="ຜູ້ບັນທຶກ">
                            <b-form-input v-model="user.username"></b-form-input>
                        </b-form-group>

                    </b-card>



                </b-col>
            </b-row>


        </b-form>


        <b-card>
            <b-row>
                <b-col cols="2" md="2">
                    <b-form-group label="ເລກບັນຊີ(ໜີ້)">
                        <b-input-group>
                            <b-form-input v-model="fld.account_code_dr" v-mask="'########.##.########'" placeholder="________.__.________"
                            @blur="$refs.amt_dr.$el.focus()"     trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" text="Button" variant="danger" v-b-modal.modal-acc>
                                    <b-icon icon="search"></b-icon>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="2" md="2">

                    <b-form-group label="ເລກບັນຊີ(ມີ)">
                        <b-input-group>
                            <b-form-input v-model="fld.account_code_cr" v-mask="'########.##.########'" placeholder="________.__.________"
                             @blur="$refs.amt_cr.$el.focus()"     trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" text="Button" variant="success">
                                    <b-icon icon="search" v-b-modal.modal-accdr></b-icon>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>


                </b-col>
                <b-col cols="2" md="2">
                    <b-form-group label="ລາຍການກິດຈະກຳ">
                        <b-input-group>
                            <b-form-input v-model="fld.item_id" trim> </b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" text="Button" variant="success">
                                    <b-icon icon="search" v-b-modal.modal-items></b-icon>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        
                    </b-form-group>
                </b-col>
                <!-- <b-col>
                    <b-form-group label="ໝາຍເຫດ">
                        <b-form-input v-model="fld.remark" trim></b-form-input>
                    </b-form-group>
                </b-col> -->
                <b-col cols="2" class="text-center">
                    

                    <b-form-group label="ໜີ້">
                         <!-- <vue-numeric ref="amt_dr" currency="" class="p-1 text-right" separator="," v-model="fld.debit">
                        </vue-numeric>  -->
                        <!-- <number ref="amt_dr"  v-model="fld.debit" class="p-1 text-right" ></number> -->

                        <nice-numeric-input v-model="fld.debit" ref="amt_dr" name="debit" noControls   label="" /> 
                    </b-form-group>
                </b-col>
                <b-col cols="2" class="text-center">
                    <b-form-group label="ມີ">

                         <!-- <vue-numeric ref="amt_cr" currency="" class="p-1 text-right" separator="," v-model="fld.credit">
                        </vue-numeric>  -->
                        <!-- <number ref="amt_cr"  v-model="fld.credit" class="p-1 text-right" ></number> -->
                        <nice-numeric-input v-model="fld.credit" ref="amt_cr" name="credit" noControls   label=""/> 


                    </b-form-group>
                </b-col>
                <b-col cols="2" md="2">
                    <b-form-group label="...">
                        <b-button @click="onAdditem" variant="primary" >ເພິ່ມລາຍການ</b-button>
                    </b-form-group>
                    
                </b-col>

            </b-row>
            <b-row>
                <b-col md="4">   {{ fld.description }} </b-col>
                <b-col>  {{ item_desc }}   </b-col>
            </b-row>
        </b-card>


        <b-table head-variant="light" hover :fields="fields" :items="rows" class="border  mt-2" foot-clone>
            <template #cell(debit)="{ item }">

                <span v-if="!item.editing">
                    {{ item.debit | format }}
                </span>
                <vue-numeric v-else v-model="item.temp['debit']" @keydown.enter.exact="doSave(item)" class="text-right">
                </vue-numeric>

            </template>
            <template #cell(credit)="{ item }">

                <span v-if="!item.editing">
                    {{ item.credit | format }}
                </span>
                <vue-numeric v-else v-model="item.temp['credit']" @keydown.enter.exact="doSave(item)"
                    class="text-right"></vue-numeric>

            </template>

            <template #cell(action)="{ item }">

                <b-link v-if="!item.editing" @click="doEdit(item)">
                    <b-icon icon="pencil"></b-icon>
                </b-link>
                <b-link v-if="!item.editing" @click="onRemoveItem(item.account_code)">
                    <b-icon icon="trash" variant="danger"></b-icon>
                </b-link>
                <b-button-group>
                    <b-btn v-if="item.editing" @click="doSave(item)" variant="success">
                        <b-icon icon="check2-circle"></b-icon>
                    </b-btn>
                    <b-btn v-if="item.editing" @click="doCancel(item)" variant="danger">
                        <b-icon icon="x-circle-fill"></b-icon>
                    </b-btn>
                </b-button-group>


            </template>
            <template #foot(account_code_dr)="data">
                <span class="text-danger"></span>
            </template>
            <template #foot(account_code_cr)="data">
                <span class="text-danger"></span>
            </template>
            <template #foot(item_id)="data">
                <span class="text-danger"></span>
            </template>
            <template #foot(description)="data">
                <span class="text-danger">ລວມ:</span>
            </template>
            // eslint-disable-next-line vue/no-unused-vars
            <template #foot(debit)="data">
                <span class="text-danger">{{ drTotal }}</span>
            </template>
            // eslint-disable-next-line vue/no-unused-vars
            <template #foot(credit)="data">
                <span class="text-success">{{ crTotal }}</span>
            </template>
            // eslint-disable-next-line vue/no-unused-vars
            <template #foot(local_debit)="data">
                <span class="text-danger">{{ format( parseFloat( unformat( drTotal))* gltrans.rate) }}</span>
            </template>
            // eslint-disable-next-line vue/no-unused-vars
            <template #foot(local_credit)="data">
                <span class="text-success">{{ format( parseFloat( unformat(crTotal))* gltrans.rate)  }}</span>
            </template>

        </b-table>


        <b-overlay>
            <b-modal ref="accdr-modal" id="modal-acc" title="ຄົ້ນຫາເລກບັນຊີ...." hide-footer size="lg"
                header-bg-variant="primary" header-text-variant="white">
                <b-form-group label-cols="4" label-cols-lg="3" label="ຄົ້ນຫາ:">
                    <b-form-input v-model="txtfind" @input="doFindAcc"></b-form-input>
                </b-form-group>
                <b-table :items="accounts" @row-dblclicked="RowBblclickAccDr"></b-table>
            </b-modal>

            <b-modal ref="acccr-modal" id="modal-accdr" title="ຄົ້ນຫາເລກບັນຊີ...." hide-footer size="lg"
                header-bg-variant="primary" header-text-variant="white">
                <b-form-group label-cols="4" label-cols-lg="3" label="ຄົ້ນຫາ:">
                    <b-form-input v-model="txtfind" @input="doFindAcc"></b-form-input>
                </b-form-group>
                <b-table :items="accounts" @row-dblclicked="RowBblclickAccCr"></b-table>
            </b-modal>
        </b-overlay>

    </div>
</template>

<script>
import axios from "axios";

export default {
    computed: {
        crTotal() {

            let sum = this.rows.reduce(function (total, currentValue) {
               //   console.log(currentValue.credit)
                return total + parseFloat(currentValue.credit);
            }, 0);

            console.log(sum)

            return this.format(sum);

        },
        drTotal() {

            let sum = this.rows.reduce(function (total, currentValue) {
               //   console.log(currentValue.debit)
                return total + parseFloat(currentValue.debit);
            }, 0);

            return this.format(sum);

        },
    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getRows/v_gltranssub/doc_no/" + this.$route.params.val
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.rows = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getRows/gltrans/doc_no/" + this.$route.params.val
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.gltrans = response.data[0];
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/v_dep/branch_name/branch_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.dep = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/funding_source/funding_desc/funding_code"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.source_fund = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/v_transaction_type/trans_type_desc/trans_type_code"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.glbook = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/payment_types/payment_type_desc/payment_type_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.payment_types = response.data;
                //    console.log(  JSON.parse(response.data))
            })

    },
    data() {
        return {
            txtfind: "",
            totaldr: 0,
            totalcr: 0,
            source_fund: [],
            dep: [],
            glbook: [],
            accounts: [],
            payment_types: [],
            plan_flds:[{label: 'ລະຫັດ', key: 'value'},{label: 'ກິດຈະກຳ', key: 'text'}],
            item_desc:'',
            plan_items:[],
            "gltrans":
            {
                "doc_no": this.$route.params.val,
                "doc_date": "",
                "description": " ",
                "ref_doc_no": "",
                "ref_doc_date": null,
                "amount": 0,
                "local_amount": 0,
                "f_currency_code": "KIP",
                "rate": 1,
                "status": "Posted",
                "create_date": "",
                "create_by": "",
                "posting_date": "",
                "posting_by": "",
                "islock": "Y",
                "proj_code": "",
                "book_code": "",
                "rate_id": 1,
                "currency_code": "01",
                "branch_id": "",
                "fdelete": "N",
                "delete_by": null,
                "delete_date": null,
                "trans_type_code": "",
                "total_debit": 0.00,
                "total_credit": 0.00,
                "detail": "",
                "cheque_no": "",
                "bank_code": "",
                "bank_account_no": "",
                "sector_code": null,
                "cs": 0.00,
                "cq": 0.00,
                "tr": 0.00,
                "cust_code":"",
                "dep_code":""
            }
            ,

            fld: {
                "code": "",
                "doc_no": "",
                "line_number": 1,
                "account_code": "",
                "account_code_dr": "",
                "account_code_cr": "",
                "debit": 0.00,
                "credit": 0.00,
                "currency_code": "KIP",
                "local_debit": 0,
                "local_credit": 0.00,
                "create_by": "",
                "create_date": null,
                "description": "",
                "remark": "",
                "rate_id": 1,
                "fdelete": "N",
                "delete_by": null,
                "delete_date": null,
                "branch_id": "",
                "trans_code": "",
                "item_id":""
            },
            fields: [
                { label: 'ເລກບັນຊີ(ໜີ້)', key: 'account_code_dr', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ເລກບັນຊີ(ມີ)', key: 'account_code_cr', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ລະຫັດກິດຈະກຳ', key: 'item_id', thClass: "text-nowrap ", tdClass: "text-nowrap " },
                { label: 'ເນື້ອໃນ', key: 'description' , thClass: "col-md-1  text-nowrap ", tdClass: "col-md-2 text-nowrap", },
                { label: 'ໜີ້', key: 'debit', thClass: "col-md-1  text-right ", tdClass: "col-md-2 text-right", formatter: "format" },
                { label: 'ມີ', key: 'credit', thClass: "col-md-1  text-right", tdClass: "col-md-2  text-right", formatter: "format" },
                { label: 'ໜີ້(ກີບ)', key: 'local_debit', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                { label: 'ມີ(ກີບ)', key: 'local_credit', thClass: "col-md-2  text-right", tdClass: "col-md-2  text-right", formatter: "format" },
                { label: '...', key: 'action', thClass: "  text-right", tdClass: " text-right" },
            ],
            items: [],
            user: [],

            "rows": []
        }

    }
    ,
    methods: {
        goback() {
            this.$router.go(-1);
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2,
  maximumFractionDigits: 2,}).format(number)
            return amt
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        doEdit(item) {

            this.$set(item, 'temp', JSON.parse(JSON.stringify(item)))
            this.$set(item, 'editing', true)
            //  this.$refs['modal-edit-item'].show()
        },
        doSave(item) {

            this.$set(item, 'editing', false)
            for (let key in item.temp) {
                // console.log(key)
                if (item[key] != item.temp[key]) {
                    item[key] = item.temp[key]
                }
            }
        },
        doCancel(item) {
            this.$set(item, 'editing', false)
            this.$delete(item, 'temp')
        },
        onAdditem() {
            //console.log('enter')

            let account_code = ''
            if (this.fld.account_code_dr != '') {
                account_code = this.fld.account_code_dr
            } else {
                account_code = this.fld.account_code_cr
            }
            let itm = {
                "doc_no": "",
                "line_number": 1,
                "account_code": account_code,
                "account_code_dr": this.fld.account_code_dr,
                "account_code_cr": this.fld.account_code_cr,
                "debit": this.fld.debit,
                "credit": this.fld.credit,
                "currency_code": "KIP",
                "local_debit": this.fld.debit,
                "local_credit": this.fld.credit,
                "create_by": this.user.username,
                "create_date": null,
                "description": this.fld.description,
                "remark": "",
                "rate_id": 1,
                "fdelete": "N",
                "delete_by": null,
                "delete_date": null,
                "branch_id": "0000",
                "trans_code": "0103"
            }

            this.rows.push(itm)

            this.fld = {
                "code": "",
                "doc_no": "",
                "line_number": 1,
                "account_code": "",
                "account_code_dr": "",
                "account_code_cr": "",
                "debit": 0.00,
                "credit": 0.00,
                "currency_code": "KIP",
                "local_debit": 0,
                "local_credit": 0.00,
                "create_by": "",
                "create_date": null,
                "description": "",
                "remark": "",
                "rate_id": 1,
                "fdelete": "N",
                "delete_by": null,
                "delete_date": null,
                "branch_id": "",
                "trans_code": ""
            }


        },
        onRemoveItem(code) {
            // this.rows.splice(index, 1)
            //   console.log(code)

            this.rows = this.rows.filter(item => item.account_code != code);
        },
        RowBblclickAccDr(item) {
            this.fld.account_code_dr = item.account_code
            this.fld.description = item.account_name
            this.fld.account_code_cr = ""
            this.$refs['accdr-modal'].hide()
        },

        RowBblclickAccCr(item) {
            this.fld.account_code_cr = item.account_code
            this.fld.description = item.account_name
            this.fld.account_code_dr = ""
            this.$refs['acccr-modal'].hide()
        },
        doFindAcc() {
            //   getAccounts
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getAccounts/" + this.user.branch_id + "/" + this.txtfind
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.accounts = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
        },
        onUpdatePosting(event){
            event.preventDefault()
            this.gltrans.amount = this.unformat(this.crTotal)
            this.gltrans.local_amount =parseFloat( this.unformat(this.crTotal)) * parseFloat(this.gltrans.rate)
            let params={
                hd: this.gltrans,
                items:this.rows
            }


            axios.post(  this.$store.getters.getBaseUrl +'/updateglposting',params)
            .then(res => {
                console.log(res)
            })
            .catch(err => {
                console.error(err); 
            })


            console.log(params)


        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
        onPreview(){
           

           let    rpt_param={
           script:"call  sp_voucher ('"+ this.gltrans.doc_no +"')",
           branch_id:this.user.branch_id
           }
        //   this.fld.script=`call sp_account_hist('`+this.fld.branch_id+`','`+this.fld.from_date+`','`+this.fld.to_date+`','`+this.fld.account_code+`')`
           let data = JSON.stringify(rpt_param);
           this.$router.push('/view_dna/rpt_voucher.mrt?data='+data)
       }


    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', {  minimumFractionDigits: 2,
  maximumFractionDigits: 2,}).format(number)
            return amt
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },

    }

}
</script>

<style scoped>
</style>